import { useTranslation } from "react-i18next";
import styles from "./map.module.css";
import { toDateTime } from "../../../Services/string.service";

export default function InfoWindow(props) {
  const { t } = useTranslation();

  // se for mapVisits, renderiza somente a placa
  if (props.activeTab === "mapVisits") { 
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "16px",
        }}
      >
      <strong>{t("INFO_WINDOW.VEHICLE")}: </strong> {props.data?.plate ?? "Origem"}
      </div>
    );
  }
  
  return (
    <div
    className={styles.cardInfo}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className={styles.getMarkerContent}>
        <div
          id="street-view-preview"
          style={{ width: "90%", height: "300px", border: "1px solid #000" }}
        ></div>

        {!props.hideIcons ? (
          <div className="d-flex flex-row">
            {/* seus ícones aqui */}
          </div>
        ) : (
          ""
        )}
      </div>

      <div style={{ width: 1200 }} className={styles.tableInfoWindow}>
        <h5 className={styles.infoWindowSubtitle}> <strong>Data e hora de registro: </strong>{toDateTime(props.data.generatedAt)}</h5>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody style={{width: 500}}>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.VEHICLE")}:</strong>
              </td>
              <td>{props.data?.plate}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.MODEL")}:</strong>
              </td>
              <td>
                {props.data?.vehicleModelName}
              </td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.MANUFACTURER")}:</strong>
              </td>
              <td>
                {props.data?.vehicleManufacturerName} 
              </td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.YEAR")}:</strong>
              </td>
              <td>
                {props.data?.vehicleYear}
              </td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.CATEGORY")}:</strong>
              </td>
              <td>{props.data?.vehicleCategoryName}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.ADDRESS")}:</strong>
              </td>
              <td style={{width: 200}}>{props.data?.location}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.STATUS")}:</strong>
              </td>
              <td>{props.data?.speedStatusDesc}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.EVENT")}:</strong>
              </td>
              <td>{props.data?.event}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.DRIVER")}:</strong>
              </td>
              <td>{props.data?.userDriverName}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.IGNITION_BATTERY")}:</strong>
              </td>
              <td>{props.data?.ignition}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.GROUP")}:</strong>
              </td>
              <td>{props.data?.vehicleGroupName}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.SPEED")}:</strong>
              </td>
              <td>{props.data?.speed} Km/H</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.ODOMETER")}:</strong>
              </td>
              <td>{props.data?.hodometer}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.TIME_ELAPSED")}:</strong>
              </td>
              <td>{props.data?.time}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.TRACKER_BATTERY")}:</strong>
              </td>
              <td>{props.data?.backupBattery}</td>
            </tr>
            <tr>
              <td>
                <strong>{t("INFO_WINDOW.VEHICLE_BATTERY")}:</strong>
              </td>
              <td>{props.data?.mainBattery}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}